<template>

	<div class="text-center">

		<img class="img-circle" :src="student.photoURL">
		<h4>{{ student.name }}</h4>

	</div>

</template>

<script>

	import StudentsName from './';
	export default StudentsName;

</script>

<style lang="scss" scoped>

	.img-circle {
		width: 65px;
		height: 65px;
		margin: 17px;
	}

</style>



// WEBPACK FOOTER //
// name.vue?2909c0fe